/**
 * Analytics tracking has been removed.
 * This hook is kept as a no-op so existing useAnalyticsTracking() and trackEvent() calls do not break.
 */
export const useAnalyticsTracking = () => {
  const trackEvent = () => {};
  return { trackEvent };
};
